export default function splitRoomString(roomString = '') {
  const roomStr = roomString.split('-');
  let roomCount = parseInt(roomStr[0], 10);
  let paxCount = 0;
  let childCount = 0;
  let childAgeArray = [];
  if (roomStr.length > 2) {
    paxCount = parseInt(roomStr[1], 10);
    childCount = parseInt(roomStr[2], 10);
    // childCount = parsedChildCount ? parseInt(roomStr[2].split('_')[0], 10) : parsedChildCount;
  }
  if (childCount > 0 && roomStr.length > 3) {
    childAgeArray = roomStr[3].split('_');
    childAgeArray = childAgeArray.map(item => parseInt(item, 10));
  }
  return {roomCount, paxCount, childCount, childAgeArray};
}
